var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1658_1349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8958 28.6146C12.3765 28.5511 12.8621 28.6814 13.245 28.9764L15.0098 30.3306C15.5931 30.7787 16.4046 30.7787 16.9863 30.3306L18.8179 28.9242C19.1601 28.6619 19.5919 28.5462 20.0188 28.6032L22.3099 28.9047C23.0383 29.0008 23.7406 28.5951 24.0225 27.9155L24.904 25.784C25.0686 25.3848 25.3847 25.0686 25.784 24.9041L27.9153 24.0224C28.5948 23.7422 29.0006 23.0382 28.9045 22.3098L28.6144 20.1017C28.5509 19.6209 28.6812 19.1353 28.9762 18.7524L30.3303 16.9875C30.7784 16.4041 30.7784 15.5926 30.3303 15.0108L28.924 13.1792C28.6617 12.837 28.546 12.4051 28.603 11.9782L28.9045 9.68699C29.0006 8.95857 28.5948 8.25621 27.9153 7.9743L25.784 7.09269C25.3847 6.9281 25.0686 6.61196 24.904 6.21271L24.0225 4.08122C23.7422 3.40168 23.0383 2.99592 22.3099 3.09206L20.0188 3.39353C19.5919 3.4522 19.1601 3.3365 18.8195 3.07576L16.988 1.66943C16.4046 1.2213 15.5931 1.2213 15.0114 1.66943L13.1798 3.07576C12.8376 3.3365 12.4058 3.4522 11.9789 3.39679L9.68783 3.09532C8.95945 2.99917 8.25714 3.40494 7.97523 4.08448L7.09531 6.21597C6.9291 6.61359 6.61297 6.92973 6.21538 7.09595L4.084 7.97593C3.4045 8.25784 2.99876 8.96019 3.0949 9.68862L3.39635 11.9798C3.45176 12.4068 3.33606 12.8386 3.07534 13.1792L1.66909 15.0108C1.22098 15.5942 1.22098 16.4058 1.66909 16.9875L3.07534 18.8192C3.33769 19.1614 3.45339 19.5932 3.39635 20.0202L3.0949 22.3114C2.99876 23.0398 3.4045 23.7422 4.084 24.0241L6.21538 24.9057C6.6146 25.0703 6.93073 25.3864 7.09531 25.7857L7.97686 27.9171C8.25714 28.5967 8.96108 29.0025 9.68946 28.9063L11.8958 28.6146Z",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.667 16.6667L14.0003 20L21.3337 12.6667",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1658_1349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP5);
export default __webpack_public_path__ + "static/media/p5.d92a40d635e461b5e655631da08ce4a5.svg";
export { ForwardRef as ReactComponent };